module.exports = __webpack_public_path__ + "static/media/VN.faa818be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/VN.svg
// module id = 2289
// module chunks = 7